/**
 * Input + Textarea — the canonical form-input primitives. Replaces the
 * inline IS / TA / EF.base style objects scattered across CRM,
 * NewBusiness, Pricing, etc.
 */
const BASE = {
  background: 'var(--bg-input)',
  border: '1px solid var(--border-soft)',
  borderRadius: 'var(--radius)',
  color: 'var(--text-primary)',
  fontSize: 13,
  padding: '7px 10px',
  width: '100%',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border-color 0.12s, box-shadow 0.12s',
};

export function Input({ style, invalid, ...props }) {
  return (
    <input
      style={{
        ...BASE,
        borderColor: invalid ? 'var(--danger)' : BASE.border,
        ...style,
      }}
      {...props}
    />
  );
}

export function Textarea({ style, invalid, rows = 3, ...props }) {
  return (
    <textarea
      rows={rows}
      style={{
        ...BASE,
        borderColor: invalid ? 'var(--danger)' : BASE.border,
        resize: 'vertical',
        minHeight: 60,
        fontFamily: 'inherit',
        ...style,
      }}
      {...props}
    />
  );
}

export function Select({ style, invalid, children, ...props }) {
  return (
    <select
      style={{
        ...BASE,
        borderColor: invalid ? 'var(--danger)' : BASE.border,
        cursor: 'pointer',
        ...style,
      }}
      {...props}
    >
      {children}
    </select>
  );
}

export function Label({ style, children, ...props }) {
  return (
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: 4,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
